import { instance } from 'api/internaltools';

export const getFeesBreakdownReport = async (startTime, endTime, entityIds = []) => {
  const params = { start_time: startTime, end_time: endTime };

  if (entityIds?.length) {
    params.entity_ids = entityIds;
  }

  // Serialize array params as repeated keys (entity_ids=e1&entity_ids=e2) so the
  // backend's []string binding picks up every entity id.
  return instance.get('/fees-breakdown-report', {
    params,
    paramsSerializer: { indexes: null },
  });
};
